import React from "react";

import FinlandLayout from "../../components/FinlandLayout";

const Page = ({ location }) => {
	const title = "Subpage";
	const trail = [
		{ title: "Finland", to: "/finland" },
		{ title: title, to: "/finland/subpage" }
	];
	return (
		<FinlandLayout title={title} trail={trail} location={location.pathname} />
	);
};

export default Page;
